import { gql } from "@apollo/client";

const UPDATE_TEAM = gql`
  mutation updateTeam(
    $id: Int!
    $title: String
    $country: String
    $status: String
    $sport: Int
    $club: Int
    $platform: Int
    $members: [JSONObject!]
    $discipline: Int
    $image: Upload
    $phone: String
    $email: String
    $website: String
    $instagramLink: String
    $facebookLink: String
    $twitterLink: String
    $tiktokLink: String
  ) {
    updateTeam(
      updateTeamInput: {
        id: $id
        title: $title
        country: $country
        status: $status
        sport: $sport
        club: $club
        members: $members
        platform: $platform
        discipline: $discipline
        image: $image
        phone: $phone
        email: $email
        website: $website
        instagramLink: $instagramLink
        facebookLink: $facebookLink
        twitterLink: $twitterLink
        tiktokLink: $tiktokLink
      }
    ) {
      id
      title
      status
      country
      image
    }
  }
`;

export default UPDATE_TEAM;
